import React from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import PropTypes from "prop-types";
import WorkItemForm from "./WorkItemForm";
import "./WorkItemForms.css";

function WorkItemForms({ workItem }) {
  if (workItem.forms.length === 0) {
    return (
      <Row>
        <Col>This work item has no forms</Col>
      </Row>
    );
  }

  if (workItem.forms.length === 1) {
    return (
      <Row>
        <Col>
          <WorkItemForm form={workItem.forms[0]} mode="single" />
        </Col>
      </Row>
    );
  }

  return (
    <Container className="coreContent mt-1">
      <Row>
        <Col>
          <Accordion>
            {workItem.forms.map((form) => (
              <WorkItemForm
                key={form.cleanData.createdOn}
                mode="multi"
                form={form}
              />
            ))}
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
}

WorkItemForms.propTypes = {
  workItem: PropTypes.shape({
    forms: PropTypes.arrayOf(
      PropTypes.shape({
        cleanData: PropTypes.shape({
          id: PropTypes.string,
        }),
      })
    ),
  }).isRequired,
};

export default WorkItemForms;
